import { render, staticRenderFns } from "./InitialAcceptTermsAndConditions.vue?vue&type=template&id=4772e66c&"
import script from "./InitialAcceptTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./InitialAcceptTermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports